import api from '@/axios'
import type {GlobalSearchResponse} from "@/types/search";

export const searchApi = {
    globalSearch: async (searchTerm: string, maxResultsPerType = 10): Promise<GlobalSearchResponse> => {
        const response = await api.get('/api/search/global', {
            params: {
                searchTerm,
                maxResultsPerType
            }
        })
        return response.data
    }
}
